import Logframe from '../../features/Logframe';

type ProjectLogFramePropsType = {
    projectID: number;
};
const LogFrameWrapper = ({ projectID }: ProjectLogFramePropsType) => <Logframe id={projectID} />;

export default LogFrameWrapper;
